import { Box, Typography } from "@mui/material"
import { format, isValid } from "date-fns"
import Iconify from "minimals-template/components/Iconify"

export function ArchivedBanner({ archivedAt }) {
    const timestamp = formatTimestamp(archivedAt)
    const lead = timestamp ? `Archived on ${timestamp}.` : "Archived."

    return (
        <Box
            data-cy="archived-banner"
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 2,
                py: 1.25,
                borderRadius: 1,
                bgcolor: "grey.200",
                color: "grey.800",
            }}
        >
            <Iconify icon="material-symbols:archive-outline" width={20} />
            <Typography variant="body2">
                <Typography component="span" sx={{ fontWeight: 700 }}>
                    {lead}
                </Typography>{" "}
                This work package is read only. Amends documents and review cycles remain available.
            </Typography>
        </Box>
    )
}

function formatTimestamp(value) {
    if (!value) return null
    const date = new Date(value)
    if (!isValid(date)) return null
    return format(date, "d MMM yyyy 'at' h:mmaaa")
}
